import { Factory } from 'miragejs';

export default Factory.extend({
  startTime() {
    const now = new Date();
    const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);
    return tomorrow.toISOString();
  },

  shouldSendNotification() {
    return true;
  },

  scheduledBy() {
    return null;
  },

  afterCreate(assignment, server) {
    // Create a desk if one doesn't exist
    if (!assignment.desk) {
      assignment.desk = server.create('graphql/desk');
    }

    // Create an employee if one doesn't exist
    if (!assignment.employee) {
      assignment.employee = server.create('graphql/employee');
    }

    if (!assignment.scheduledBy) {
      assignment.scheduledBy = server.create('graphql/employee');
    }
  },
});
